export default defineNuxtRouteMiddleware((to) => {
  const path = to.path
  const hasQueryParams = Object.keys(to.query).length > 0

  // Podstránky, kde riešime logiku kraj/region
  const listingBases = [
    '/kancelarie',
    '/obchodne-priestory',
    '/en/offices',
    '/en/retail',
  ]

  // Zistíme, či aktuálna URL patrí pod niektorú z týchto ciest
  const matchedBase = listingBases.find(
    (basePath) => path === basePath || path.startsWith(basePath + '/')
  )

  let isRegionFilter = false

  if (matchedBase && !hasQueryParams) {
    if (path.endsWith('-kraj') || path.endsWith('-region')) {
      isRegionFilter = true
    }
  }

  // Noindex pre:
  // - stránky s filtrom na kraj/region
  if (isRegionFilter) {
    useHead({
      meta: [
        {
          name: 'robots',
          content: 'noindex, follow',
        },
      ],
    })
  }
})
